import React, { useContext } from 'react';
import {
  Field,
  ImageField,
  ComponentRendering,
  SitecoreContext,
  withSitecoreContext,
  Image,
  LinkFieldValue,
  WithSitecoreContextProps,
} from '@sitecore-jss/sitecore-jss-react';
import './index.scss';
import { APIWebstoreContext } from '../../context/globalContext';

export type LOBListFieldProps = {
  Title: Field<string>;
  Description: Field<string>;
  DesktopImage: ImageField;
  ImageHeight: Field<string>;
  ImageWidth: Field<string>;
  Link: Field<LinkFieldValue>;
};

export type LOB = {
  fields: LOBListFieldProps;
  displayName: string;
};

export type LOBListDetailsProps = {
  fields: {
    LOBs: Array<LOB>;
  };
  sitecoreContext?: SitecoreContext & { pageEditing: boolean };
  rendering: ComponentRendering;
  isCentered?: boolean;
};

const ContinueShoppingSection = (
  props: LOBListDetailsProps & WithSitecoreContextProps
): JSX.Element => {
  const sitecoreState = useContext(APIWebstoreContext);

  if (props.fields && props.fields.LOBs && props.fields.LOBs.length > 0) {
    return (
      <div className={`continue-shopping-section ${props.isCentered ? 'center-aligned' : ''}`}>
        <h3>
          {sitecoreState?.state?.sitecoreDictionaryData &&
          sitecoreState?.state?.sitecoreDictionaryData?.ContinueShoppingMessage
            ? sitecoreState?.state?.sitecoreDictionaryData.ContinueShoppingMessage
            : 'To explore more, visit:'}
        </h3>

        <div className="lob-list">
          {props.fields.LOBs.map((LOB, index) => {
            const link = LOB.fields.Link.value?.href;
            return (
              <div key={index} className="lob-item">
                <a
                  href={link}
                  target={LOB.fields.Link?.value?.target}
                  title={LOB.fields.Link?.value?.title}
                  rel="noopener noreferrer"
                >
                  <div className="lob-item-content">
                    <Image
                      field={LOB.fields.DesktopImage.value}
                      className="lob-item-image"
                      alt={LOB.fields.Title.value}
                      style={{
                        width: `${LOB.fields?.ImageWidth?.value}px`,
                        height: `${LOB.fields?.ImageHeight?.value}px`,
                      }}
                    />
                    <p className="lob-item-title">{LOB.fields.Title.value}</p>
                  </div>
                </a>
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  return <></>;
};

export default withSitecoreContext()(ContinueShoppingSection);
